import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/filter/filter';

class FadvFilterComponent extends FadvBaseComponent {
    constructor(base) {
        super(base);
    }
    getFilterValuesByCategory() {
        var _a, _b;
        return (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.getFilterValuesByCategory();
    }
}
FadvFilterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvFilterComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvFilterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvFilterComponent, selector: "fadv-filter", inputs: { panelSize: "panelSize", buttonSize: "buttonSize" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvFilterComponent.prototype, "panelSize", void 0);
__decorate([
    Forward()
], FadvFilterComponent.prototype, "buttonSize", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvFilterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-filter',
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { panelSize: [{
                type: Input
            }], buttonSize: [{
                type: Input
            }] } });

class FadvFilterModule {
}
FadvFilterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvFilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvFilterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvFilterModule, declarations: [FadvFilterComponent], imports: [FadvCommonModule], exports: [FadvFilterComponent] });
FadvFilterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvFilterModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvFilterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvFilterComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvFilterComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvFilterComponent, FadvFilterModule };
